$(document).ready(function () {
  const input = $('#header-search-input');
  const results = $('.thb-predictive-search');

  // Run only if input exists
  if (input.length) {

    input.on('blur', function () {
      // If the newly focused element is NOT inside <search-form>, close it
      if (!$(document.activeElement).closest('search-form').length) {
        $('body').removeClass('open-search');
        results.attr('inert', '');
      }
    });

  }

  // document.addEventListener("click", function(e) {
  //   const link = e.target.closest('.header--inner .full-menu a[href="#"]');
  //   if (link) {
  //     e.preventDefault();
  //   }
  // });
});
